module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921125651_T.0ca3fabe.jpg";